import styled from 'styled-components';
import {FooterLayout} from '@templates';

export const StyledFooterLayout = styled(FooterLayout)`
  align-items: center;
  background: ${({theme}) => theme.background.white};
  border-top: 1px solid ${({theme}) => theme.divider.grey};
  box-shadow: ${({theme}) => theme.boxShadow.secondary};
`;
